<div class="product-dialog" [style.visibility]="!!this.step">
  <div class="product-dialog__wrapper">
    <span>{{ title }}</span>

    <lp-product-steps-wizard [step]="step" [steps]="steps"></lp-product-steps-wizard>

    <div class="product-dialog__content">
      <ng-container *ngIf="loading" [ngTemplateOutlet]="loaderTmp"></ng-container>

      <ng-container [ngSwitch]="step">
        <lp-product-common-step
          *ngSwitchCase="'common'"
          [product]="product"
          [product$]="product$"
          [(stepForm)]="stepForm"
        ></lp-product-common-step>

        <lp-product-contacts-step
          *ngSwitchCase="'contacts'"
          [product]="product"
          [product$]="product$"
          [isAdvertiser]="isAdvertiser"
          [(stepForm)]="stepForm"
        ></lp-product-contacts-step>

        <lp-product-terms-step
          *ngSwitchCase="'terms'"
          [product]="product"
          [product$]="product$"
          [(stepForm)]="stepForm"
        ></lp-product-terms-step>
      </ng-container>
    </div>

    <div class="product-dialog__actions">
      <div class="hint">
        {{ 'components.productDialog.labels.offerAgreementPart1' | translate: { value: applyTitle } }}
        <app-download-link
          class="download-manual-link"
          fileLink="assets/docs/lp-offer-agreement.pdf"
          [showIcon]="false"
        >
          {{ 'components.productDialog.labels.offerAgreementPart2' | translate }}
        </app-download-link>
      </div>

      <div class="buttons">
        <button
          tuiButton
          [disabled]="loading"
          appearance="grey-button"
          type="button"
          [size]="isMobile ? 'm' : 'l'"
          (click)="back()"
          [style.visibility]="canMoveBack ? 'unset' : 'hidden'"
          [style.display]="isMobile && !canMoveBack ? 'none' : 'inherit'"
        >
          {{ 'common.buttons.return' | translate }}
        </button>

        <div class="buttons_block">
          <button
            tuiButton
            [disabled]="loading"
            appearance="secondary"
            type="button"
            [size]="isMobile ? 'm' : 'l'"
            (click)="close()"
          >
            {{ 'common.buttons.cancel' | translate }}
          </button>

          <button tuiButton [loading]="loading" type="button" [size]="isMobile ? 'm' : 'l'" (click)="apply()">
            {{ applyTitle }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loaderTmp>
  <div class="position-by-center">
    <tui-loader size="l" [showLoader]="true" [inheritColor]="true" [overlay]="true" style="width: 100%"></tui-loader>
  </div>
</ng-template>
